import React from 'react';
import { StyledRating } from '../StyledRating';
import { Typography } from "@material-ui/core";
import { useStyles } from './SellerNotations.style';
export const SellerNotations = ({ numberOfSale, sellerRating }) => {
    const { typography, content, sizeSmall, bullet } = useStyles();
    const salesInteger = numberOfSale ? parseInt(numberOfSale.replace(/\s+/g, ''), 10) : 0;
    const salesWording = salesInteger > 1000 ? `+ de 1 000 ventes` : `${numberOfSale} vente${salesInteger > 1 ? 's' : ''}`;
    if (numberOfSale === '0' || numberOfSale === '') {
        return (React.createElement(Typography, { className: typography, "data-qa": "sellerNotations", align: 'left' }, "Nouveau vendeur"));
    }
    return (React.createElement("div", { className: content, "data-qa": "sellerNotations" },
        !!sellerRating &&
            React.createElement(StyledRating, { name: 'notation', defaultValue: 1, max: 1, className: sizeSmall, readOnly: true }),
        React.createElement(Typography, { className: typography },
            (!!sellerRating) && `\u00A0 ${sellerRating}`,
            (!!sellerRating) && React.createElement("span", { className: bullet }, " "),
            salesWording)));
};
